<template>
  <div class="footer">
    <div class="sign-up">
      <h1>Get Started with PowerSlide</h1>
      <p>
        We can help you get up and running, start using PowerSlide digital signage today. Click the sign up button below.
      </p>
      <div class="button" v-on:click="getStarted">
        Get Started Today!
      </div>
    </div>
    <div class="footer-content">
      <h4>
        PowerSlide
      </h4>

      <div class="row">
        <div class="link" v-on:click="landing">
          Home
        </div>
        <div class="link" v-on:click="solutions">
          Solutions
        </div>
        <div class="link" v-on:click="about">
          About
        </div>
        <div class="link" v-on:click="faq">
          FAQ
        </div>
        <div class="link" v-on:click="login">
          Login
        </div>
        <div class="link" v-on:click="getStarted">
          Get Started Today!
        </div>
        <div class="link" v-on:click="contact">
          Contact
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',

  data () {
    return {

    }
  },

  methods: {
    about: function () {
      if (this.$route.path !== '/about') {
        this.$router.push('/about')
      }
    },

    contact: function () {
      if (this.$route.path !== '/contact') {
        this.$router.push('/contact')
      }
    },

    faq: function () {
      if (this.$route.path !== '/faq') {
        this.$router.push('/faq')
      }
    },

    getStarted: function () {
      this.$gtag.event('footer-get-started-today', { method: 'Google' })
      this.$router.push('/get-started')
    },

    landing: function () {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },

    login: function () {
      this.$router.push('/login')
    },

    solutions: function () {
      if (this.$route.path !== '/solutions') {
        this.$router.push('/solutions')
      }
    }
  }
}
</script>

<style scoped>
  .button {
    font-size: 1em;
    margin-top: .5em;
    padding: 1em;
    width: 200px;
  }

  h1 {
    margin: 0;
  }

  h4 {
    margin: 1em 0 0 0;
  }

  .link {
    cursor: pointer;
    display: inline-block;
    padding: .5em;
  }

  .link:hover {
    color: var(--secondary);
  }

  .footer {
    background: var(--footer-bg) !important;
  }

  .footer-content {
    padding: 2em;
    text-align: center;
  }

  .sign-up {
    background-color: #eaeaea;
    padding: 2em;
    text-align: center;
  }

</style>
